/* eslint-disable eqeqeq, no-unused-vars, array-callback-return, consistent-return, guard-for-in,no-restricted-syntax, no-plusplus, no-return-assign, no-mixed-operators */
import { Button, Col, Form, Input, InputNumber, Row, Select, Table } from 'antd'
import {
  AssetTurnoverRatio, BookValueperShare, CashConversion, EarningPerhead, EarningPerShare,
  EDIT_ANUAL_BOARD, GrossMargin, IMPORT_CSV, Institutional, PriceSaleRatio, PriceToBookRatio,
  PriceToEarningRatio, ProfitMargin, ReturnOnAsset, ReturnOnEquity, RevenuePerHead, RevenuePerShare
} from 'Assets'
import ChartBar from 'Components/chart/bar-chart'
import ToolTip from 'Components/tooltip'
import {
  useAuth, useDashboard, useRoot, useVisibleTutorial
} from 'Hooks'
import Papa from 'papaparse'
import React, { useEffect, useState } from 'react'
import 'react-datasheet/lib/react-datasheet.css'
import { Trans, useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'
import styled from 'styled-components'
import ChartNoData from '../../Components/chart/no-data'
import ChartPie from '../../Components/chart/pie-chart'
import GridSheet from '../../Components/form/GridSheet'
import Loading from '../../Components/loading'
import ModalComponent from '../../Components/modal'
import { WrapperTutorial } from '../../Components/private-title'
import AnnualAssetsGoalsTutorial from '../../Components/tutorial/AnnualAssetsGoalsTutorial'
import GowthTutorial from '../../Components/tutorial/GrowthTutorial'
import { ROLE_TYPE } from '../../Constants/permission'
import { useLocalStorage } from '../../Hooks/useLocalStorage'
import { SUCCESS } from '../../Stores'
import { getLocalStorage } from '../../Utils'
import { mergeFieldArray } from '../../Utils/array'
import {
  DELETE_PORTFOLIO_BY_ID, UPDATE_ASSET_GOALS,
  UPDATE_GROWTH_SCHEDULES
} from './store/constants'

const { Option } = Select

const DashBoardStyled = styled.div`
  .ant-input {
    &-number {
      border-top: 0;
      border-left: 0;
      border-right: 0;

      input {
        width: 100% !important;

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
      }
    }
  }

  .ant-input-number-handler-wrap {
    display: none !important;
  }

  .annual-title {
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      font-weight: 700;
      font-size: 18px;
      line-height: 20px;

      color: ${({ theme }) => theme.black};
    }

    button {
      margin-left: 13px;
      border: none;
      background: none;
    }
  }

  @media only screen and (max-width: 767px) {
    ${Col} {
      width: 100%;
    }
  }
`

const KeyFieldWrapper = styled.div`
  display: flex;
  align-items: center;

  .tooltip-wrapper {
    margin-left: 10px;
  }
  .text-currency {
    color: gray;

    cursor: pointer;
  }
`

const TableWrapper = styled(Table)`
  .ant-table-cell {
    &:before {
      display: none !important;
    }
  }

  input {
    width: 70px !important;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  tr {
    &:nth-child(13) {
      .ant-table-cell {
        width: 100%;
        border: none;

        &:hover {
          background: none;
        }

        .tooltip-wrapper {
          display: none;
        }

        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4) {
          display: none;
        }
      }
    }

    &:nth-child(14),
    &:nth-child(15),
    &:nth-child(16) {
      .ant-table-cell {
        padding: 16px 30px;
      }
    }
  }

  .ant-table-thead {
    & > tr {
      & > th {
        background: transparent;
        font-weight: 700;
        font-size: 15px;
        line-height: 20px;
        min-width: 120px;
        color: #000000;
      }
    }
  }

  .ant-table-tbody {
    & > tr > td {
      font-weight: 700;
      font-size: 12px;
      line-height: 20px;

      color: #000000;
    }
  }
`

const DashBoardButton = styled(Button)`
  height: 40px;
  width: 80px;

  &:first-of-type {
    margin-right: 34px;
  }

  &:last-of-type {
    margin-left: 34px;
  }
`
const EditContentWrapper = styled.div`
  margin-top: 26px;

  .ant-input {
    margin-top: 16px;
    height: 40px;
  }
`

const Title = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }) => theme.black};
`

const Content = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  padding: 20px;
  color: #616161;
  white-space: pre;
`

const DeletePortfolioButton = styled(Row)`
  margin-top: 38px;
  justify-content: flex-end;
`

/**
 *
 * @param gridInitData {array}
 * @returns {[{readOnly: boolean, value: string}]}
 */
export const getGridColumns = (gridInitData) => {
  if (gridInitData?.length > 0) {
    let gridHeader = [{ field: '' }]
    gridInitData?.forEach((item) => gridHeader.push({
      field: item.year
    }))

    return gridHeader
  }
  return null
}

/**
 *
 * @param gridInitData {array}
 * @param key {string}
 * @returns {[{readOnly: boolean, value: string}]}
 */
const getGridData = (gridInitData, key) => {
  if (gridInitData?.length > 0) {
    let gridHeader = []
    gridInitData?.forEach((item) => {
      gridHeader.push({
        id: item.id,
        [key]: item[key]
      })
    })

    return gridHeader
  }
  return null
}

// eslint-disable-next-line react/prop-types
export default function DashBoard(effect, deps) {
  const [editingRow, setEditingRow] = useState(false)
  const [editingGROWTH, setEditingGROWTH] = useState(false)
  const [submitData, setSubmitData] = useState(null)
  const [importGrowthData, setImportGrowthData] = useState(null)
  const { tutorialShow } = useVisibleTutorial()
  const history = useHistory()
  const [inviteCode] = useLocalStorage('inviteCode')
  const { id } = useParams()
  const { t } = useTranslation(['dashboard', 'common', 'error_message'])
  const {
    isLoading,
    assetGoalsData,
    growthSchedulesData,
    userInvite,
    updateAssetGoalsSuccess,
    portFolioById,
    success,
    deletePortFolioByIdAction,
    updateAnnualAssetGoalsAction,
    updateGrowthSchedulesAction,
    getPortFolioByIdAction,
    isCompanyAdmin,
    isPortfolioAdmin,
    isEditor,
    isUser,
    updateCurrencyAction
  } = useDashboard()

  const { profile } = useAuth()
  const [dataSource, setDataAssetGoals] = useState(null)
  const [visibleDeletePortfolio, setDeleteVisiblePortfolio] = useState(false)
  const [visibleDeletePortfolioConfirm, setVisibleDeletePortfolioConfirm] = useState(false)
  const [visibleChangeCurrency, setVisibleChangeCurrency] = useState(false)
  const [currencyType, setCurrencyType] = useState('USD')
  useEffect(() => {
    getPortFolioByIdAction({ id })
  }, [id])

  const deletePortfolio = () => {
    setDeleteVisiblePortfolio(true)
  }
  useEffect(() => {
    if (assetGoalsData) {
      let newArray = []
      // eslint-disable-next-line no-restricted-syntax
      for (const a of assetGoalsData) {
        newArray.push({
          key: a?.id,
          items: t(a?.item),
          goal: a?.goal,
          present: a?.present,
          last_year: a?.last_year
        })
      }

      setDataAssetGoals(newArray)
    }
  }, [assetGoalsData])

  const [fieldChange, setFieldChange] = useState({
    goal: '',
    achievement: ''
  })

  useEffect(() => {
    setCurrencyType(portFolioById?.currency)
    setFieldChange({
      goal: portFolioById?.goal_content,
      achievement: portFolioById?.achivement_content
    })
  }, [portFolioById])

  const { showModalMessageAction, hideOverlayAction, showOverlayAction } = useRoot()
  const [form] = Form.useForm()

  const openCurrencyModal = () => {
    if (!isUser && !editingGROWTH) {
      setVisibleChangeCurrency(true)
    }
  }
  const renderCurrency = () => (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <span
      className="text-currency"
      onClick={() => {
        openCurrencyModal()
      }}
    >{portFolioById?.currency}
    </span>
  )

  const columns = [
    {
      title: 'Items',
      dataIndex: 'items',
      render: (text, record, index) => (
        <KeyFieldWrapper>
          <span>{text}</span>
          {index === 0 && (
            <span className="tooltip-wrapper">
              <ToolTip>
                <AssetTurnoverRatio />
              </ToolTip>
            </span>
          )}
          {index === 1 && (
            <>
              <span className="tooltip-wrapper">
                <ToolTip>
                  <ReturnOnEquity />
                </ToolTip>
              </span>
              <span>&nbsp;&nbsp;(%)</span>
            </>
          )}
          {index === 2 && (
            <>
              <span className="tooltip-wrapper">
                <ToolTip>
                  <ReturnOnAsset />
                </ToolTip>
              </span>
              <span>&nbsp;&nbsp;(%)</span>
            </>
          )}
          {index === 3 && (
            <>
              <span className="tooltip-wrapper">
                <ToolTip>
                  <BookValueperShare />
                </ToolTip>
              </span>
              <span>&nbsp;&nbsp;({renderCurrency()})</span>
            </>
          )}
          {index === 4 && (
            <>
              <span className="tooltip-wrapper">
                <ToolTip>
                  <EarningPerShare className="1111" />
                </ToolTip>
              </span>
              <span>&nbsp;&nbsp;({renderCurrency()})</span>
            </>
          )}
          {index === 5 && (
            <>
              <span className="tooltip-wrapper">
                <ToolTip>
                  <RevenuePerShare />
                </ToolTip>
              </span>
              <span>&nbsp;&nbsp;({renderCurrency()})</span>
            </>
          )}
          {index === 6 && (
            <>
              <span className="tooltip-wrapper">
                <ToolTip>
                  <RevenuePerHead />
                </ToolTip>
              </span>
              <span>&nbsp;&nbsp;({renderCurrency()})</span>
            </>
          )}

          {index === 7 && (
            <>
              <span className="tooltip-wrapper">
                <ToolTip>
                  <EarningPerhead />
                </ToolTip>
              </span>
              <span>&nbsp;&nbsp;({renderCurrency()})</span>
            </>
          )}
          {index === 8 && (
            <>
              <span className="tooltip-wrapper">
                <ToolTip>
                  <GrossMargin />
                </ToolTip>
              </span>
              <span>&nbsp;&nbsp;(%)</span>
            </>
          )}
          {index === 9 && (
            <>
              <span className="tooltip-wrapper">
                <ToolTip>
                  <ProfitMargin />
                </ToolTip>
              </span>
              <span>&nbsp;&nbsp;(%)</span>
            </>
          )}
          {index === 10 && (
            <>
              <span className="tooltip-wrapper">
                <ToolTip>
                  <CashConversion />
                </ToolTip>
              </span>
              <span>&nbsp;&nbsp;(days)</span>
            </>
          )}
          {index === 11 && (
            <>
              <span className="tooltip-wrapper">
                <ToolTip>
                  <Institutional />
                </ToolTip>
              </span>
              <span>&nbsp;&nbsp;(count)</span>
            </>
          )}
          {index === 13 && (
            <span className="tooltip-wrapper">
              <ToolTip>
                <PriceToEarningRatio />
              </ToolTip>
            </span>
          )}
          {index === 14 && (
            <span className="tooltip-wrapper">
              <ToolTip>
                <PriceToBookRatio />
              </ToolTip>
            </span>
          )}
          {index === 15 && (
            <span className="tooltip-wrapper">
              <ToolTip>
                <PriceSaleRatio />
              </ToolTip>
            </span>
          )}
          <span
            style={{
              marginLeft: 15
            }}
          >
            {index === 13 && '>'}
            {index === 14 && '>'}
            {index === 15 && '>'}
          </span>
        </KeyFieldWrapper>
      )
    },
    {
      title: 'GOAL',
      dataIndex: 'goal',
      render: (text, record) => {
        if (editingRow) {
          return (
            <Form.Item name={`goal-${record.key}`}>
              <InputNumber min={0} max={10000000000} name={`goal-${record.key}`} />
            </Form.Item>
          )
        }
        return <p>{text && text.toLocaleString()}</p>
      }
    },
    {
      title: 'PRESENT',
      dataIndex: 'present',
      render: (text, record) => {
        if (editingRow) {
          return (
            <Form.Item name={`present-${record.key}`}>
              <InputNumber min={0} max={10000000000} name={`present-${record.key}`} />
            </Form.Item>
          )
        }
        return <p>{text && text.toLocaleString()}</p>
      }
    },
    {
      title: 'LAST YEAR',
      dataIndex: 'last_year',
      render: (text, record) => {
        if (editingRow) {
          return (
            <Form.Item name={`last_year-${record.key}`}>
              <InputNumber min={0} max={10000000000} name={`last_syear-${record.key}`} />
            </Form.Item>
          )
        }
        return <p>{text && text.toLocaleString()}</p>
      }
    }
  ]

  const onFinish = (values) => {
    let newObj = {}
    let newArray = []

    for (const prop in values) {
      const [name, idObj] = prop.split('-')
      let value = parseFloat(values[prop])
      if (Number.isNaN(value)) {
        value = null
      }
      newObj = {
        ...newObj,
        id: parseInt(idObj, 10),
        [name]: value
      }
      newArray.push(newObj)
    }

    const resultData = mergeFieldArray(newArray, 'id')
    updateAnnualAssetGoalsAction({
      assetGoals: resultData,
      id
    })
  }

  function handleChangeField(e) {
    setFieldChange({ ...fieldChange, [e.target.name]: e.target.value })
  }

  function handleSubmitForm() {
    let message = ''
    if (submitData) {
      if (
        submitData.some((item) => (item.required || item.requred !== 0) && !(item.required >= 0))
      ) {
        return showModalMessageAction({ message: 'REQUIRED value must be >= 0' })
      }
      if (submitData.some((item) => (item.raised || item.raised !== 0) && !(item.raised >= 0))) {
        return showModalMessageAction({ message: 'RAISED value must be >= 0' })
      }
      // const getEntityErr = submitData.filter((item) => (item?.required || item?.raised) && (item?.required > 0 && !(item?.raised > 0) || item?.raised > 0 && !(item?.required > 0)))

      // if (getEntityErr && getEntityErr.length > 0) {
      //   return showModalMessageAction({ message: 'REQUIRED value or Raised fields must be >= 0' })
      // }
      const getRequiredArrayField = submitData && submitData.map((item) => item.required).filter((required) => required != null)
      const getRaisedArrayField = submitData && submitData.map((item) => item.raised)
      const findRaisedField = getRaisedArrayField.find((item) => item > 0)
      const maxRequired = Math.max(...getRequiredArrayField)
      if (findRaisedField && (maxRequired === 0 || !getRequiredArrayField.length)) {
        return showModalMessageAction({ message: 'The REQUIRED values can not be all zero' })
      }

      // eslint-disable-next-line no-mixed-operators
      const rates = getRaisedArrayField.map((item) => Number((((item || 0) * 100) / maxRequired).toFixed(2)))

      let percents = Array(getRaisedArrayField.length).fill(0)
      // eslint-disable-next-line prefer-destructuring
      percents[0] = rates[0]

      let total = rates[0]

      for (let i = 1; i < rates.length; i++) {
        let num = Math.max(rates[i] - rates[i - 1], 0)
        if (total + num > 100) {
          return showModalMessageAction({ message: 'Total Raise Rates must be <= 100%' })
          // num = 100 - total
        }
        total += num
      }

      const newData = {
        goal: fieldChange.goal,
        achievement: fieldChange.achievement,
        growthSchedules: [...submitData]
      }
      return updateGrowthSchedulesAction({
        ...newData,
        id
      })
    }
  }

  useEffect(() => {
    if (success === SUCCESS(UPDATE_ASSET_GOALS)) {
      setEditingRow(false)
    }
    if (success === SUCCESS(UPDATE_GROWTH_SCHEDULES)) {
      setEditingGROWTH(false)
    }
  }, [success])

  useEffect(() => {
    if (updateAssetGoalsSuccess) {
      setEditingRow(false)
    }
  }, [updateAssetGoalsSuccess])

  const submitDeletePortfolio = () => {
    deletePortFolioByIdAction({ id })
  }

  useEffect(() => {
    if (success === SUCCESS(DELETE_PORTFOLIO_BY_ID)) {
      setDeleteVisiblePortfolio(false)
      setVisibleDeletePortfolioConfirm(true)
    }
  }, [success])

  /**
   *
   * @param {HTMLInputElement} event
   * @param {'GROWTH' | 'ANNUAL'} type
   */
  // eslint-disable-next-line consistent-return
  const handleSubmitFile = (event, type) => {
    const getFiles = event.target.files[0]
    if (getFiles.type !== 'text/csv') {
      return showModalMessageAction({ message: t('error_message:FILE_TYPE_NOT_CORRECT_CSV') })
    }
    showOverlayAction()
    if (event.target.files.length > 0) {
      switch (type) {
        case 'ANNUAL':
          let resultAnnualParser = []

          return Papa.parse(event.target.files[0], {
            header: true,
            dynamicTyping: true,
            skipEmptyLines: true,
            error: (message) => {
              showModalMessageAction({ message })
              hideOverlayAction()
            },
            step(row, parser) {
              parser.pause()
              try {
                if (
                  !('goal' in row.data)
                  || !('last_year' in row.data)
                  || !('present' in row.data)
                  || !('item' in row.data)
                ) {
                  throw new Error(t('error_message:FILE_CONTENT_NOT_CORRECT'))
                }
                if (row.data.item !== 'STOCK_BUYBACK') {
                  // eslint-disable-next-line eqeqeq
                  if (row.data.goal || row.data.goal == '0') row.data.goal = Number(row.data.goal)
                  // eslint-disable-next-line eqeqeq
                  if (row.data.last_year || row.data.last_year == '0') row.data.last_year = Number(row.data.last_year)
                  // eslint-disable-next-line eqeqeq
                  if (row.data.present || row.data.present == '0') row.data.present = Number(row.data.present)
                  if (
                    Number.isNaN(row.data.goal)
                    || Number.isNaN(row.data.last_year)
                    || Number.isNaN(row.data.present)
                  ) {
                    throw new Error(t('error_message:FILE_CONTENT_NOT_CORRECT'))
                  }
                }
                resultAnnualParser.push(row.data)
              } catch (e) {
                showModalMessageAction({ message: e })
                return hideOverlayAction()
              }
              parser.resume()
            },
            complete() {
              resultAnnualParser = assetGoalsData
                .map((value) => {
                  const assetGoal = resultAnnualParser.find((x) => x.item === value.item)
                  if (assetGoal) assetGoal.id = value.id
                  return assetGoal
                })
                .filter(Boolean)

              const dt = resultAnnualParser.reduce((acc, item) => {
                acc[`goal-${item.id}`] = item.goal
                acc[`last_year-${item.id}`] = item.last_year
                acc[`present-${item.id}`] = item.present
                return acc
              }, {}) || {}
              form.setFieldsValue(dt)
              hideOverlayAction()
            }
          })
        case 'GROWTH':
          let resultParserGrowthData = []

          return Papa.parse(event.target.files[0], {
            header: true,
            dynamicTyping: true,
            skipEmptyLines: true, // eslint-disable-next-line consistent-return
            error: (message) => {
              showModalMessageAction({ message })
              hideOverlayAction()
            },
            step(row, parser) {
              parser.pause()
              try {
                if (
                  !('arr' in row.data)
                  || !('raised' in row.data)
                  || !('required' in row.data)
                  || !('schedule' in row.data)
                  || !('yoy' in row.data)
                  || !('year' in row.data)
                  || !('series' in row.data)
                ) {
                  throw new Error(t('error_message:FILE_CONTENT_NOT_CORRECT'))
                }
                if (row.data.arr || row.data.arr == '0') row.data.arr = Number(row.data.arr)
                if (row.data.raised || row.data.raised == '0') row.data.raised = Number(row.data.raised)
                if (row.data.required || row.data.required == '0') row.data.required = Number(row.data.required)
                if (row.data.schedule || row.data.schedule == '0') row.data.schedule = Number(row.data.schedule)
                if (row.data.yoy || row.data.yoy == '0') row.data.yoy = Number(row.data.yoy)
                if (row.data.year || row.data.year == '0') row.data.year = Number(row.data.year)
                if (
                  Number.isNaN(row.data.arr)
                  || Number.isNaN(row.data.raised)
                  || Number.isNaN(row.data.required)
                  || Number.isNaN(row.data.schedule)
                  || Number.isNaN(row.data.yoy)
                  || Number.isNaN(row.data.year)
                ) {
                  throw new Error(t('error_message:FILE_CONTENT_NOT_CORRECT'))
                }
                // if (row.data.yoy !== null && row.data.yoy > MAX_INPUT_1M_NUMBER) row.data.yoy = MAX_INPUT_1M_NUMBER
                // if ((row.data.yoy !== null && row.data.yoy > 1000000) || row.data.yoy < 0) {
                //   return showModalMessageAction({
                //     message: t('error_message:FILE_CONTENT_MUST_BE_RANGE_MIN_1_MAX_100')
                //   })
                // }
                if (row.data.raised !== null && row.data.raised < 0) {
                  throw new Error(t('error_message:Raised field must be >= 0'))
                }
                if (row.data.required !== null && row.data.required < 0) {
                  throw new Error(t('error_message:Required field must be >= 0'))
                }
                resultParserGrowthData.push(row.data)
              } catch (e) {
                showModalMessageAction({ message: e })
                return hideOverlayAction()
              }
              parser.resume()
            },
            complete() {
              resultParserGrowthData = (submitData || growthSchedulesData)
                .map((value) => {
                  const dataItem = resultParserGrowthData.find((x) => x.year === value.year)
                  if (!dataItem) return value
                  dataItem.id = value.id
                  return dataItem
                })
                .filter(Boolean)
              setImportGrowthData(resultParserGrowthData)
              hideOverlayAction()
            }
          })
        default:
          break
      }
    }
  }

  const handleGrowthCancel = () => {
    setFieldChange({
      goal: portFolioById?.goal_content || '',
      achievement: portFolioById?.achivement_content || ''
    })
    setSubmitData(growthSchedulesData)
    setEditingGROWTH(false)
  }

  const wheelHandler = (e) => {
    e.preventDefault()
  }

  useEffect(() => {
    const getInputNumberType = document.querySelectorAll('input[type=number]')
    getInputNumberType.forEach((item) => {
      item.addEventListener('wheel', wheelHandler)
    })

    return () => getInputNumberType.forEach((item) => {
      item.removeEventListener('wheel', wheelHandler)
    })
  }, [editingRow, editingGROWTH])

  const editableField = () => {
    setEditingRow(true)
    const dt = assetGoalsData.reduce((acc, item) => {
      acc[`goal-${item.id}`] = item.goal
      acc[`last_year-${item.id}`] = item.last_year
      acc[`present-${item.id}`] = item.present
      return acc
    }, {}) || {}
    form.setFieldsValue(dt)
  }

  const hasRequiredData = portFolioById && Array.isArray(assetGoalsData) && Array.isArray(growthSchedulesData)
  if (isLoading || !hasRequiredData) {
    return <Loading loadingMini />
  }

  return (
    <>
      <DashBoardStyled>
        <Row gutter={24}>
          <Col sm={24} md={12}>
            <div className="annual-title">
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%'
                }}
              >
                <WrapperTutorial>
                  {t('common:ANNUAL_ASSET_GOALS')}
                  {!isUser && !editingRow && (
                    <>
                      {profile?.lastLogin === null && tutorialShow === 2 && (
                        <AnnualAssetsGoalsTutorial />
                      )}

                      <button onClick={editableField} style={{ cursor: 'pointer' }}>
                        <EDIT_ANUAL_BOARD />
                      </button>
                    </>
                  )}
                </WrapperTutorial>

                {editingRow && ( // eslint-disable-next-line jsx-a11y/label-has-associated-control
                  <label className="file">
                    <input
                      onClick={(e) => (e.target.value = null)}
                      accept="text/csv"
                      type="file"
                      id="file"
                      hidden
                      onChange={(e) => handleSubmitFile(e, 'ANNUAL')}
                    />
                    {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
                    <span style={{ cursor: 'pointer' }}>
                      <IMPORT_CSV />
                    </span>
                  </label>
                )}
              </span>
            </div>

            <div className="annual-dashboard">
              <Form form={form} onFinish={onFinish}>
                <TableWrapper
                  columns={columns}
                  dataSource={dataSource}
                  pagination={false}
                  defaultExpandAllRows
                />

                {editingRow === true && (
                  <Row
                    justify="center"
                    style={{
                      marginTop: '16px'
                    }}
                  >
                    <DashBoardButton type="cancel" onClick={() => setEditingRow(false)}>
                      {t('cancel')}
                    </DashBoardButton>

                    <DashBoardButton type="primary" htmlType="submit">
                      {t('save')}
                    </DashBoardButton>
                  </Row>
                )}
              </Form>
            </div>
          </Col>
          <Col sm={24} md={12}>
            <div className="annual-title">
              <span>
                {t('common:ARR_GROWTH_SCHEDULE')}
                {!isUser && !editingGROWTH && (
                  <button
                    onClick={() => {
                      setEditingGROWTH(true)
                    }}
                  >
                    <WrapperTutorial>
                      <EDIT_ANUAL_BOARD style={{ cursor: 'pointer' }} />
                      {profile?.lastLogin === null && tutorialShow === 3 && <GowthTutorial />}
                    </WrapperTutorial>
                  </button>
                )}
                {editingGROWTH && ( // eslint-disable-next-line jsx-a11y/label-has-associated-control
                <label className="file">
                  <input
                    onClick={(e) => (e.target.value = null)}
                    accept="text/csv"
                    type="file"
                    id="file"
                    hidden
                    onChange={(e) => handleSubmitFile(e, 'GROWTH')}
                  />
                  {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
                  <span style={{ cursor: 'pointer', marginLeft: '20px' }}>
                    <IMPORT_CSV />
                  </span>
                </label>
                )}
              </span>
              <span style={{
                fontWeight: '700',
                fontSize: '18px'
              }}
              >
                CAPITAL REQUIRED for GOAL
              </span>
            </div>
            {(() => {
              const chartData = editingGROWTH && submitData?.length ? submitData : growthSchedulesData
              const hasChartData = chartData?.length
                && !(getGridData(chartData, 'arr')?.every((el) => el.arr === null)
                  && (getGridData(chartData, 'raised')?.every((el) => el.raised === null)
                    || getGridData(chartData, 'required')?.every((el) => el.required === null)))
              return !hasChartData ? (
                <ChartNoData />
              ) : (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 28
                  }}
                >
                  <ChartBar data={chartData} />
                  <ChartPie initData={chartData} />
                </div>
              )
            })()}

            <GridSheet
              arrData={getGridData(growthSchedulesData, 'arr') || []}
              yoyData={getGridData(growthSchedulesData, 'yoy') || []}
              requiredData={getGridData(growthSchedulesData, 'required') || []}
              raisedData={getGridData(growthSchedulesData, 'raised') || []}
              scheduleData={getGridData(growthSchedulesData, 'schedule') || []}
              seriesData={getGridData(growthSchedulesData, 'series') || []}
              editingGROWTH={editingGROWTH}
              growthSchedulesData={growthSchedulesData}
              setSubmitData={setSubmitData}
              valueImports={importGrowthData}
              openCurrencyModal={openCurrencyModal}
              currencyType={portFolioById?.currency}
            />

            <EditContentWrapper>
              {editingGROWTH ? (
                <>
                  <Title>{t('common:goal')}</Title>
                  <Input.TextArea
                    name="goal"
                    value={fieldChange.goal}
                    onChange={(e) => handleChangeField(e)}
                  />
                  <Title>{t('common:achievement')}</Title>
                  <Input.TextArea
                    name="achievement"
                    value={fieldChange.achievement}
                    onChange={(e) => handleChangeField(e)}
                  />
                </>
              ) : (
                <>
                  <Title>{t('common:goal')}</Title>
                  <Content>{fieldChange.goal}</Content>
                  <Title>{t('common:achievement')}</Title>
                  <Content>{fieldChange.achievement}</Content>
                </>
              )}
            </EditContentWrapper>
            {editingGROWTH && (
              <Row
                justify="center"
                style={{
                  marginTop: '16px'
                }}
              >
                <DashBoardButton type="cancel" onClick={handleGrowthCancel}>
                  {t('cancel')}
                </DashBoardButton>

                <DashBoardButton type="primary" onClick={() => handleSubmitForm()}>
                  {t('save')}
                </DashBoardButton>
              </Row>
            )}
          </Col>
        </Row>
        {portFolioById?.role === ROLE_TYPE.COMPANY_ADMIN && (
          <DeletePortfolioButton>
            <Button type="primary" onClick={deletePortfolio}>
              {t('common:deletePortfolioButton')}
            </Button>
          </DeletePortfolioButton>
        )}

        {/* <DeletePortfolioButton> */}
        {/*  <Button type="primary" onClick={deletePortfolio}>Delete This Portfolio</Button> */}
        {/* </DeletePortfolioButton> */}

        {visibleDeletePortfolio && (
        <ModalComponent
          title={t('common:DELETE_PORTFOLIO')}
          themeMode="light"
          onCancel={() => setDeleteVisiblePortfolio(false)}
          visible
          onSubmit={submitDeletePortfolio}
          modalWith={412}
          onSubmitText={t('common:delete')}
        >
          <>
            <Trans
              t={t}
              components={{
                br: <br />
              }}
            >
              common:deletePortfolioMessage
            </Trans>
          </>
        </ModalComponent>
        )}

        {visibleDeletePortfolioConfirm && (
        <ModalComponent
          title={t('common:DELETE_PORTFOLIO')}
          themeMode="light"
          visible
          onSubmit={() => setVisibleDeletePortfolioConfirm(false)}
          cancel={false}
          showCloseButton={false}
        >
          {t('common:deletedPortfolioMessage')}
        </ModalComponent>
        )}

        {visibleChangeCurrency && (
        <ModalComponent
          title={t('common:currency_setting')}
          themeMode="light"
          visible
          onSubmit={() => {
            const payload = {
              id: portFolioById?.id,
              currency: currencyType
            }
            updateCurrencyAction(payload)
            setVisibleChangeCurrency(false)
          }}
          onSubmitText={t('common:save')}
          onCancel={() => {
            setCurrencyType(portFolioById?.currency)
            setVisibleChangeCurrency(false)
          }}
          showCloseButton={false}
        >
          <div style={{
            textAlign: 'center'
          }}
          >
            <span style={{ width: '30%', marginRight: '20px', fontSize: '14px', fontWeight: '500' }}>
              {t('common:currency')} :
            </span>
            <Select
              className="content-currency"
              defaultValue={currencyType}
              style={{
                width: '60%'
              }}
              onChange={(value) => {
                setCurrencyType(value)
              }}
            >
              <Option value="USD">USD</Option>
              <Option value="JPY">JPY</Option>
            </Select>
          </div>
        </ModalComponent>
        )}
      </DashBoardStyled>
    </>
  )
}
